export default "__VITE_ASSET__baJ8tz41__"